import { render, staticRenderFns } from "./Consults.vue?vue&type=template&id=3be37ccc&scoped=true&"
import script from "./Consults.vue?vue&type=script&lang=js&"
export * from "./Consults.vue?vue&type=script&lang=js&"
import style0 from "./Consults.vue?vue&type=style&index=0&id=3be37ccc&scoped=true&lang=css&"
import style1 from "./Consults.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be37ccc",
  null
  
)

export default component.exports